export const LIST_PLATFORM_REQUEST = 'LIST_PLATFORM_REQUEST';
export const LIST_PLATFORM_SUCCESS = 'LIST_PLATFORM_SUCCESS';
export const LIST_PLATFORM_ERROR = 'LIST_PLATFORM_ERROR';